import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { Notification } from 'types';
import { client } from 'utils/api-client';

function useCommunication(communicationsId: string): UseQueryResult<AxiosResponse<Notification>> {
  return useQuery(
    ['communications', communicationsId],
    () => client.get(`notifications/${communicationsId}`),
    { enabled: !!communicationsId },
  );
}

export default useCommunication;
